/**
 * The F-16 notice's words (ProvePhoneBanner.tsx; Prest0n Everywhere S1c-1b-2, Miles 2026-10-22: "prompt once"): the
 * number a YES reply to a text confirmed, that soon such a reply won't count, and the action that leads to Settings.
 * One table for both designs' bands, which draw the notice the source registers. In a module of their own, as the
 * install offer's are, so the band's own checks read them (bannerConciseness follows a source's `./…Copy` import to
 * its phone line).
 */
export const PROVE_PHONE_COPY = {
  words: (display: string): string => `you confirmed ${display} by replying yes to a text. soon that won't count — confirm it with a code.`,
  /* The phone line: one row on a 390px screen, the action beside it. */
  wordsShort: 'confirm your number with a code.',
  action: 'confirm it',
} as const;
